import { colors as themeColors } from '../utils/theme';
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Snackbar, Alert, Grid, CircularProgress, Paper, FormGroup, FormControlLabel, Checkbox, TextField, InputAdornment, Dialog, Autocomplete, IconButton, Button, Divider, Table, TableHead, TableRow, TableCell, TableBody, TableFooter } from "@mui/material";
import FormContainer from "../components/FormContainer";
import FloatingLabelInput from "../components/FloatingLabelInput";
// import Button from "../components/Button";
import { useCurrencyInput, formatCurrencyForDisplay } from "./utils/currencyInput";
import CitySearchInput from "../components/CitySearchInput";
import DateInput from "../components/DateInput";
import Dropdown from "../components/Dropdown";
import SearchSection from "../components/SearchSection";
import ReasonSearchDropdown from "../components/ReasonSearchDropdown";
import AddNewReasonModal from "../components/AddNewReasonModal";
import { useAuth } from '../context/AuthContext';
import LeadSourceMaster from './Test/components/LeadSourceMaster';
import AddIcon from "@mui/icons-material/Add";
import ClientMaster from './ClientMaster';
import { bgcolor, borderRadius, height } from "@mui/system";
import LeadStatusMaster from './LeadStatusMaster';
import { useTheme, useMediaQuery } from '@mui/material';
import { Category } from "@mui/icons-material";
import { toProperCase, toSentenceCase } from "../utils/formatRows";

const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
};

const convertDMYtoYMD = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";
  const [day, month, year] = parts;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

async function createSaleInvoice({ path, inquiryId, selectedFeatures, inquiryNumber, leadStatusValue, connectionString }) {
  if (leadStatusValue.toLowerCase() !== "success") return;
  try {
    await axios.post(`${connectionString}/api/saleinvoicemaster`, { inquiryId, selectedFeatures, inquiryNumber });
    console.log("Sale invoice master created");
  } catch (err) {
    console.error("Failed to create sale invoice master:", err);
  }
}

function InquiryForm({ onClose, inquiryData: propInquiryData, connectionString, onSuccess }) {
  // console.log("onClose" , onClose)
  // console.log("Inquiry Dataaa:", propInquiryData);
  const { user, selectedCompany, loading } = useAuth();
  const path = connectionString;
  const uId = user?.UserId || null;
  const companyId = selectedCompany?.CompId || null;
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formErrors, setFormErrors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);
  const [gstError, setGstError] = useState("");
  const [gstValid, setGstValid] = useState(null);
  const inquiryData = propInquiryData || location.state?.inquiryData;
  const overallMode = onClose ? "followup" : location.state?.mode || "insert";
  const [displayMode] = useState(overallMode);
  const [clientMode, setClientMode] = useState("existClient");
  const [offerPrice, setOfferPrice] = useState(0);
  const [inquiryId, setInquiryId] = useState("");
  const [inquiryNumber, setInquiryNumber] = useState("");
  const [InqDate, setInqDate] = useState("");
  const [leadsourceID, setLeadsourceID] = useState("");
  const [leadSourceValue, setLeadSourceValue] = useState("");
  const [userId, setUserId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [leadStatusID, setLeadStatusID] = useState(0);
  const [leadStatusValue, setLeadStatusValue] = useState("");
  const [priorityID, setPriorityID] = useState("");
  const [priorityValue, setPriorityValue] = useState("");
  const [mobile, setMobile] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [clientName, setClientName] = useState("");
  const [gstInNumber, setGstInNumber] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [email, setEmail] = useState("");
  const [alternateEmail, setAlternateEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [stateField, setStateField] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [pincode, setPincode] = useState("");
  const [clientId, setClientId] = useState("");
  const [requirement, setRequirement] = useState("");
  const [remarks, setRemarks] = useState("");
  const [qty, setQty] = useState("1");
  const [rate, setRate] = useState("");
  const [amount, setAmount] = useState("");
  const [nextFollowUpDate, setNextFollowUpDate] = useState("");
  const [followupDateManuallySet, setFollowupDateManuallySet] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [showReasonDropdown, setShowReasonDropdown] = useState(false);
  const [reasonOptions, setReasonOptions] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [showAddNewReasonModal, setShowAddNewReasonModal] = useState(false);
  const [addOnChecked, setAddOnChecked] = useState(false);
  const [sourceOptions, setSourceOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [usersOptions, setUsersOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [cities, setCities] = useState([]);
  const [featureOptions, setFeatureOptions] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [totalFeaturePrice, setTotalFeaturePrice] = useState(0);
  const [closingPrice, setClosingPrice] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [cityError, setCityError] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const [showAddSourceModal, setShowAddSourceModal] = useState(false);
  const { displayValue: offerDisplay, onChange: onOfferChange, onBlur: onOfferBlur, onFocus: onOfferFocus } = useCurrencyInput(offerPrice, setOfferPrice, { maxDecimals: 2 });
  const { displayValue: closingDisplay, onChange: onClosingChange, onBlur: onClosingBlur, onFocus: onClosingFocus } = useCurrencyInput(closingPrice, setClosingPrice, { maxDecimals: 2 });
  const [openClientPopup, setOpenClientPopup] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showAddStatusModal, setShowAddStatusModal] = useState(false);
  const [category, setCategory] = useState("");
  const[leadUserId , setLeadUserId] = useState(null)

  const requiredAsteriskStyle = {
    '& .MuiFormLabel-asterisk': {
      color: 'red',
    },
  };


  const EMAIL_SUGGESTIONS = [
    'nomail@gmail.com',
  ];
  const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);

  const handleFeatureToggle = (val) => {
    setSelectedFeatures(prev => prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]);
  };

  const isFormComplete = () => {
    return (
           // 🔹 Followup mode condition
    (overallMode !== "followup" || uId === leadUserId) &&
      // 🔹 Header
      InqDate?.trim() !== "" &&
      leadsourceID?.trim() !== "" &&
      userId?.toString().trim() !== "" &&

      // 🔹 Company details
      clientName.trim() !== "" &&
      contactPerson.trim() !== "" &&

      // 🔹 Mobile validation
      mobile.trim() !== "" &&
      mobile.trim().length === 10 &&

      // 🔹 Email
      email.trim() !== "" &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&

      // 🔹 Address
      area.trim() !== "" &&
      // pincode.trim() !== "" &&
      // pincode.length === 6 &&
      String(pincode).trim() !== "" &&
      String(pincode).length === 6 &&
      city.trim() !== "" &&
 
      // 🔹 Status / Priority
      leadStatusID?.toString().trim() !== "" &&
      Number(leadStatusID) !== 0 &&
      priorityID?.toString().trim() !== "" &&

      // 🔹 Dates
      nextFollowUpDate?.trim() !== "" &&

      // 🔹 Error flags
      !areaError &&
      !pincodeError &&
      !cityError
      &&
      gstValid !== false
    );
  };

  console.log("check" , uId === leadUserId , uId , leadUserId)

  useEffect(() => {
    if (!showAddStatusModal && companyId) {
      axios.get(`${path}/api/leadStatus/get-status`, { params: { CompId: companyId } })
        .then(res => {
          const opts = (res.data.data || []).map(o => ({
            LeadStatusID: o.LeadStatusID,
            LeadStatus: toProperCase(o.LeadStatus.trim()),
            IsDefault: o.IsDefault
          }));
          setStatusOptions(opts);
        })
        .catch(err => console.error("Error refetching status:", err));
    }
  }, [showAddStatusModal]);

  console.log("isFormComplete", isFormComplete())

  useEffect(() => {
    axios.get(`${path}/api/features`)
      .then(res => { setFeatureOptions(res.data); })
      .catch(err => console.error("Error loading features:", err));
  }, []);

  useEffect(() => {
    const sum = selectedFeatures
      .map(val => {
        const opt = featureOptions.find(o => o.value === val);
        return opt ? Number(opt.price) || 0 : 0;
      })
      .reduce((a, b) => a + b, 0);
    setTotalFeaturePrice(sum);
  }, [selectedFeatures, featureOptions]);

  const getTodayDate = () => new Date().toISOString().split("T")[0];
  const getFutureDate = () => {
    const dt = new Date();
    dt.setDate(dt.getDate() + 7);
    return dt.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (overallMode !== "followup") return;
    const fetchReasons = async () => {
      try {
        const res = await axios.get(`${path}/api/reasons`, { params: { companyId: selectedCompany?.CompId, search: "" } });
        const rawReasons = res.data.data || [];

        const normalizedReasons = rawReasons.map(r => ({
          ...r,
          Reason: toSentenceCase(r.Reason || ""),
          // Category: toProperCase(r.Category || ""),   // only if Category exists
        }));

        setReasonOptions(normalizedReasons);

        // setReasonOptions(res.data.data || []);
      } catch (err) {
        console.error("Error fetching reason options:", err);
      }
    };
    fetchReasons();
    console.log(overallMode);
  }, [overallMode]);

  useEffect(() => {
    if (!inquiryData) {
      setInqDate(getTodayDate());
      setNextFollowUpDate(getFutureDate());
      setOfferPrice(0);
      return;
    }
    const data = inquiryData.inquiry || inquiryData;
    console.log("data", data);
    setInquiryId(data.InqId?.toString() || "");
    setClientId(data.clientId?.toString() || "");
    setClientName(data.FirmName || "");
    setMobile(data.MobileNo || "");
    setAlternateMobile(data.AlternateMobile || "");
    setContactPerson(data.clientContact || data.ContactPerson || "");
    setEmail(data.EmailId || "");
    setAlternateEmail(data.AlternateEmailId || "");
    setGstInNumber(data.GSTNo || "");
    setAddress(data.Address || "");
    setArea(data.Area || data.area || "");
    setPincode(data.Pincode || data.pincode || "");
    setCity(data.City || data.city || "");
    setStateField(data.state || "");
    setStateCode(data.StateCode || "");
    setInquiryNumber(data.InqNo || "");
    setInqDate(data.InqDate ? formatDateForInput(data.InqDate) : "");
    setPriorityID(data.Lastpriorityid?.toString() || ""); // Ensure string
    setPriorityValue(data.Lastpriority || "");
    setLeadStatusID(data.LaststatusId ? String(data.LaststatusId) : "");
    setLeadStatusValue(data.LaststatusName || "");
    setLeadsourceID(data.LastleadSourceId ? String(data.LastleadSourceId) : String(data.leadSourceId || ""));
    setLeadSourceValue(data.LastleadSourceName || data.leadSourceName || "");
    setLeadUserId(data.UserId || null)

    if (data.LaststatusId && statusOptions.length > 0) {
      const match = statusOptions.find(
        s => String(s.LeadStatusID) === String(data.LaststatusId)
      );
      if (match) {
        setCategory(match.Category); // create state above: const [category,setCategory]=useState("")
      }
    }

    setRemarks(data.Lastremark || data.Remark || "");



    if (Array.isArray(data.Requirement)) {
      const arr = data.requirement;
      if (arr.every(x => typeof x === "string")) {
        const valueArray = arr
          .map(lbl => {
            const matching = featureOptions.find(o => o.label === lbl);
            return matching ? matching.value : null;
          })
          .filter(v => v !== null);
        setSelectedFeatures(valueArray);
      } else {
        setSelectedFeatures(arr.map(f => f.value));
      }
    } else {
      setSelectedFeatures([]);
    }
    setRequirement(Array.isArray(data.Requirement) ? "" : data.Requirement || "");
    if (data.followUpDate) {
      setNextFollowUpDate(convertDMYtoYMD(data.followUpDate));
    } else if (data.followUpDate) {
      setNextFollowUpDate(formatDateForInput(data.followUpDate));
    }
    // const failed = (data.LaststatusName || "").toLowerCase() === "failed";
    // setIsFailed(failed);
    // setShowReasonDropdown(overallMode === "followup" && failed);
    setIsFailed(false); // default, category watcher will set real value

    // 👇 support both camelCase (reasonId) and PascalCase (ReasonId) from API
    const reasonIdFromData = inquiryData?.reasonId ?? inquiryData?.ReasonId;
    const reasonTextFromData = inquiryData?.reasonText ?? inquiryData?.ReasonText ?? inquiryData?.reason ?? "";

    // if (overallMode === "followup" && reasonIdFromData != null && reasonOptions.length > 0) {
    //   const found = reasonOptions.find(opt => opt.ReasonID === reasonIdFromData);
    //   if (found) {
    //     setSelectedReason({ value: found.ReasonID, label: found.Reason });
    //   } else {
    //     setSelectedReason({ value: reasonIdFromData, label: reasonTextFromData });
    //   }
    // }

    if (overallMode === "followup" && reasonIdFromData != null) {
      // Set a fallback immediately so UI + submit sees a value
      setSelectedReason({ value: reasonIdFromData, label: reasonTextFromData });

      // If we already have fresh options, replace with canonical option object
      if (Array.isArray(reasonOptions) && reasonOptions.length > 0) {
        const found = reasonOptions.find(opt => String(opt.ReasonID) === String(reasonIdFromData));
        if (found) {
          setSelectedReason({ value: found.ReasonID, label: found.Reason });
        }
      }
    }

    setQty(data.Qty ?? "");
    setRate(data.Rate ?? "");
    setAmount(data.amount ?? "");
    const serverOffer = data.OfferPrice != null ? Number(data.OfferPrice) : 0;
    setTotalFeaturePrice(serverOffer);
    setOfferPrice(serverOffer);
    setClosingPrice(data.ClosingPrice != null ? String(data.ClosingPrice) : "");
    setAddOnChecked(Boolean(data.AddOn));
    console.log("Loaded inquiryData.offerPrice:", serverOffer);
  }, [inquiryData, featureOptions, overallMode, reasonOptions, statusOptions]);

  useEffect(() => {
    if (!leadStatusID || statusOptions.length === 0) return;

    const match = statusOptions.find(
      s => String(s.LeadStatusID) === String(leadStatusID)
    );

    if (match) {
      setCategory(match.Category);

      // show dropdown only if category is Failed
      setShowReasonDropdown(
        overallMode === "followup" && match?.Category?.toLowerCase() === "failed"
      );
    }

  }, [leadStatusID, statusOptions, overallMode]);


  useEffect(() => {
    // console.log("loggedInUser:", loggedInUser);
    // console.log("inquiryData:", inquiryData);
    if (!user) return;
    if (overallMode === "insert") {
      setUserId(String(uId));
      setEmployeeName(user?.EmployeeName || "Unknown User"); // Fallback
    } else {
      if (inquiryData) {
        const data = inquiryData.inquiry || inquiryData;
        if (data.UserId && data.EmployeeName) {
          setUserId(String(data.UserId));
          setEmployeeName(data.EmployeeName);
        } else {
          setUserId(String(uId));
          setEmployeeName(user?.EmployeeName || "Unknown User"); // Fallback
        }
      } else {
        setUserId(String(uId));
        setEmployeeName(user?.EmployeeName || "Unknown User"); // Fallback
      }
    }
  }, [user, overallMode, inquiryData]);

  useEffect(() => {
    if (!user || !userId || overallMode !== "insert") return;
    const userExists = usersOptions.some(user => String(user.UserId) === String(userId));
    if (!userExists) {
      setUsersOptions(prev => {
        const newUser = { UserId: String(uId), EmployeeName: user?.EmployeeName };
        const isDuplicate = prev.some(u => String(u.UserId) === String(newUser.UserId));
        return isDuplicate ? prev : [...prev, newUser];
      });
    }
  }, [user, userId, overallMode]);

  useEffect(() => {
    if (!showAddSourceModal && companyId) {
      axios
        .get(`${path}/api/sources`, { params: { companyId } })
        .then(res => setSourceOptions(res.data.data || []))
        .catch(err => console.error("Error refetching sources:", err));
    }
  }, [showAddSourceModal]);


  useEffect(() => {
    axios.get(`${path}/api/sources`, { params: { companyId } }).then(res => setSourceOptions(res.data.data || [])).catch(error => console.error("Error fetching sources:", error));
    axios.get(`${path}/api/leadStatus/get-status`, { params: { CompId: companyId } })
      .then(res => {
        const opts = (res.data.data || []).map(o => ({
          LeadStatusID: o.LeadStatusID,
          LeadStatus: toProperCase(o.LeadStatus.trim()),
          Category: toProperCase(o.Category.trim()),
          IsDefault: o.IsDefault
        }));
        setStatusOptions(opts);
      })
      .catch(error => console.error("Error fetching status:", error));
    axios.get(`${path}/api/users`, { params: { companyId: companyId } })
      .then(res => {
        const fetchedUsers = Array.isArray(res.data.data) ? res.data.data : [];

        const normalized = fetchedUsers.map(u => ({
          ...u,
          employeeName: toProperCase(u.employeeName || "")
        }));

        setUsersOptions(normalized);
      });

    // console.log('companyId :', companyId)
    axios.get(`${path}/api/priority`)
      .then(res => {
        // console.log(res.data.data)
        if (res.data.data) {
          const transformedOptions = res.data.data.map(item => ({
            id: String(item.PriorityId),
            value: item.value
          }));
          setPriorityOptions(transformedOptions);
        } else {
          console.error("API returned success: false");
          setPriorityOptions([]); // Ensure empty array on failure
        }
      })
      .catch(error => {
        console.error("Error fetching priorities:", error);
        setPriorityOptions([]); // Ensure empty array on error
      });
    axios.get(`${path}/api/get-cities`)
      .then(res => setCities(res.data.cities || []))
      .catch(error => console.error("Error fetching cities:", error));
  }, [selectedCompany?.CompId]);

  useEffect(() => {
    const q = parseFloat(qty) || 0;
    const r = parseFloat(rate) || 0;
    setAmount(String((q * r).toFixed(2)));
  }, [qty, rate]);

  console.log("StatusOptions", statusOptions)

  useEffect(() => {
    if (overallMode !== "insert") return;
    setPriorityID("3");
    setPriorityValue("High");
    // setLeadStatusID("1");
    // setLeadStatusValue("Pipeline");
    // setLeadsourceID("1");
    // setLeadSourceValue("Cold Call");
    if (InqDate && !followupDateManuallySet) {
      const inqDateObj = new Date(InqDate);
      const sevenDaysLater = new Date(inqDateObj);
      sevenDaysLater.setDate(inqDateObj.getDate() + 7);
      setNextFollowUpDate(sevenDaysLater.toISOString().split("T")[0]);
    }
  }, [InqDate, overallMode, followupDateManuallySet]);

  useEffect(() => {
    if (overallMode !== "insert") return;

    // ✅ Default Lead Source
    if (!leadsourceID && sourceOptions.length > 0) {
      const defaultSource = sourceOptions.find(
        s => Number(s.IsDefault) === 1
      );

      if (defaultSource) {
        setLeadsourceID(String(defaultSource.LeadsourceID));
        setLeadSourceValue(defaultSource.LeadSource);
      }
    }

    // ✅ Default Lead Status
    if (!leadStatusID && statusOptions.length > 0) {
      const defaultStatus = statusOptions.find(
        s => Number(s.IsDefault) === 1
      );

      if (defaultStatus) {
        setLeadStatusID(String(defaultStatus.LeadStatusID));
        setLeadStatusValue(defaultStatus.LeadStatus);
        setCategory(defaultStatus.Category || "");

        const isFailed =
          (defaultStatus.Category || "").toLowerCase() === "failed";

        setIsFailed(isFailed);
        setShowReasonDropdown(false);
      }
    }
  }, [overallMode, sourceOptions, statusOptions, leadsourceID, leadStatusID]);


  useEffect(() => {
    if (overallMode === "insert") {
      const fetchInquiryNumber = async () => {
        try {
          const response = await axios.get(`${path}/api/getInqNumber?companyId=${companyId}`);
          setInquiryNumber(response.data.inquiryNumber);
        } catch (error) {
          console.error("Error fetching InquiryNumber:", error);
        }
      };
      fetchInquiryNumber();
    }
  }, [overallMode]);

  const handleSourceChange = selected => {
    setLeadsourceID(selected.LeadsourceID);
    setLeadSourceValue(selected.LeadSource);
  };

  const handleAssignChange = selected => {
    console.log(selected)
    setUserId(String(selected.UserId));
    setEmployeeName(toProperCase(selected.employeeName));
  };

  const handleStatusChange = selected => {
    setLeadStatusID(Number(selected.LeadStatusID));
    setLeadStatusValue(selected.LeadStatus);
    const failed = selected.LeadStatus.toLowerCase() === "failed";
    setIsFailed(failed);
    setShowReasonDropdown(overallMode === "followup" && failed);
  };

  const handlePriorityChange = selected => {
    setPriorityID(selected.id);
    setPriorityValue(selected.value);
  };


  const handlePopupClose = (data) => {
    if (data?.success) {
      setSnackbar({
        open: true,
        message: data.message,
        severity: "success"
      });
    }
  };

  // const handleSearchByChange = selectedValue => {
  //   setNormalDropdown(selectedValue);
  // };

  const Fn_HandleNewToggle = e => {
    const checked = e.target.checked;
    setIsNew(checked);
    if (checked) {
      setClientMode("newClient");
      setIsDisabled(false);
    } else {
      setClientMode("existClient");
      setIsDisabled(true);
    }
  };

  // const Fn_HandleSearch = async (searchValue) => {
  //   setSearchText(searchValue);
  //   if (!searchValue.trim()){
  //     setSearchResults([]);
  //     setShowResults(false);
  //     return;
  //   }
  // const field = "FirmName";
  //   try {
  //     const res = await axios.get(`${path}/api/company-search`, { params: { field, search: searchValue, companyId } });
  //     if (res.status === 200) {
  //       const results = res.data.data || [];
  //       console.log("results1:", results);
  //       setSearchResults(results);
  //       setShowResults(true);
  //       if (results.length === 0) {
  //         setIsNew(true);
  //         setClientMode("newClient");
  //         setIsDisabled(false);
  //       } else {
  //         setIsNew(false);
  //         setClientMode("existClient");
  //         setIsDisabled(true);
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     if (error.response.status === 304 && field === "GSTNo") {
  //       const trimmed = searchValue.trim();
  //       setSearchText(trimmed);
  //       if (!trimmed || normalDropdown !== "GSTNo" || trimmed.length !== 15) {
  //         setSearchResults([]);
  //         setShowResults(false);
  //         return;
  //       }
  //       setGstError("");
  //       setGstLoading(true);
  //       setShowResults(true);
  //       try {
  //         // Call /api/gst-lookup with searchGstin parameter using searchValue
  //         const gstRes = await axios.get(`${path}/api/gst-lookup`, { params: { searchGstin: trimmed } });
  //         setGstValid(true);
  //         console.log("data:", gstRes.data.data);
  //         // Map response fields to form state, accounting for expected GST lookup response structure
  //         setClientName(gstRes.data.data.CompanyName || "");
  //         setContactPerson(gstRes.data.data.Contactperson || "");
  //         setAddress(gstRes.data.data.Address1 || "");
  //         setCity(gstRes.data.data.City || "");
  //         setStateField(gstRes.data.data.state || "");
  //         setStateCode(gstRes.data.data.stateCode || "");
  //         setMobile(gstRes.data.data.mobileNo || "");
  //         setEmail(gstRes.data.data.emailId || "");
  //         setPincode(gstRes.data.data.Pincode ? String(gstRes.data.data.Pincode) : "");
  //         setClientId(gstRes.data.data.clientId ? String(gstRes.data.data.clientId) : "");
  //         setIsNew(true);
  //         setClientMode("newClient");
  //         setIsDisabled(false);
  //       } catch (gstErr) {
  //         setGstValid(false);
  //         if (gstErr.response?.status === 400) {
  //           setSnackbar({ open: true, message: gstErr.response.data?.message || "GST lookup failed", severity: "error" });
  //         } else if (gstErr.response?.status === 403) {
  //           setSnackbar({ open: true, message: "GST is not Active", severity: "error" });
  //         } else {
  //           setSnackbar({ open: true, message: "Unable to fetch details for given GST No.", severity: "error" });
  //         }
  //         setGstError(gstErr.response?.data?.message || "Unable to fetch details for given GST No.");
  //         // Clear form fields on GST lookup failure
  //         setClientName("");
  //         setContactPerson("");
  //         setAddress("");
  //         setCity("");
  //         setStateField("");
  //         setStateCode("");
  //         setMobile("");
  //         setEmail("");
  //         setPincode("");
  //         setClientId("");
  //         setIsNew(true);
  //         setClientMode("newClient");
  //         setIsDisabled(false);
  //       } finally {
  //         setGstLoading(false);
  //       }
  //     } else {
  //       console.error("Error performing search:", error);
  //     }
  //   }
  // };

  const Fn_HandleSearch = async (val) => {
    setSearchText(val);
    setClientName(val);    // 🔥 live sync input

    if (!val.trim()) {
      setShowResults(false);
      setSearchResults([]);
      return;
    }
    console.log("searchValue", val)
    // CLEAR ALL if empty
    if (!val.trim()) {
      setClientName("");
      setClientId("");
      setMobile("");
      setAlternateMobile("");
      setContactPerson("");
      setEmail("");
      setAlternateEmail("");
      setGstInNumber("");
      setAddress("");
      setArea("");
      setPincode("");
      setCity("");
      setStateField("");
      setStateCode("");

      setSearchText("");
      setSearchResults([]);
      setShowResults(false);

      return;
    }


    try {
      const res = await axios.get(`${path}/api/company-search`, {
        params: { field: "FirmName", search: val, companyId }
      });

      const results = res.data.data || [];
      setShowResults(true);
      setSearchResults(results);

      if (results.length === 0) {
        setIsNew(true);
        setClientMode("newClient");
        setIsDisabled(false);

        // CLEAR previous data
        setClientId("");
        setMobile("");
        setAlternateMobile("");
        setContactPerson("");
        setEmail("");
        setAlternateEmail("");
        setGstInNumber("");
        setAddress("");
        setArea("");
        setPincode("");
        setCity("");
        setStateField("");
        setStateCode("");
      } else {
        setIsNew(false);
        setClientMode("existClient");
        setIsDisabled(true);
      }
    } catch (err) {
      console.error(err);
    }
  };


  const Fn_HandleSelectedResult = result => {
    console.log('>>>', result); // Corrected line
    setClientId(result.id);
    setClientName(result.FirmName || "");
    setMobile(result.MobileNo || "");
    setAlternateMobile(result.AlternateMobile || "");
    setContactPerson(result.ContactPerson || "");
    setEmail(result.EmailId || "");
    setAlternateEmail(result.AlternateEmailId || "");
    setGstInNumber(result.GSTNo || "");
    setAddress(result.Address || "");
    setArea(result.Area || result.area || "");
    setCity(result.City || "");
    setStateField(result.state || "");
    setStateCode(result.StateCode || "");
    setPincode(result.Pincode ? String(result.Pincode) : "");
    setClientMode("existClient");
    setIsDisabled(true);
    setIsNew(false);
    setShowResults(false);
    setSearchText("");
  };

  const handleKeyDown = useCallback(e => {
    if (e.key === "Enter") e.preventDefault();
  }, []);

  const clearFormFields = () => {
    setInquiryId("");
    setInquiryNumber("");
    setInqDate("");
    setLeadsourceID("");
    setLeadSourceValue("");
    setUserId("");
    setEmployeeName("");
    setLeadStatusID("");
    setLeadStatusValue("");
    setPriorityID("");
    setPriorityValue("");
    setMobile("");
    setClientName("");
    setGstInNumber("");
    setContactPerson("");
    setEmail("");
    setAddress("");
    setCity("");
    setStateField("");
    setStateCode("");
    setRequirement("");
    setRemarks("");
    setQty("");
    setRate("");
    setAmount("");
    setNextFollowUpDate("");
    setPincode("");
    setClientId("");
    setSelectedFeatures([]);
    setTotalFeaturePrice(0);
    setOfferPrice(0);
    setClosingPrice("");
    setAddOnChecked(false);
    setGstValid(null);
    setGstError("");
  };

  const handleClose = useCallback(() => {
    if (overallMode === "followup") {
      if (typeof onClose === "function") {
        onClose();
      }
    } else {
      navigate(-1);
    }
  }, [navigate, overallMode, onClose]);

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault();
      setFormErrors([]);
      setAreaError("");
      setPincodeError("");
      setCityError("");

      const errors = [];
      if (!clientName.trim()) {
        errors.push("Client Name is mandatory");
      }

      if (!mobile.trim()) {
        errors.push("Mobile is mandatory");
      } else if (mobile.trim().length !== 10) {
        errors.push("Mobile No must be exactly 10 digits");
      }
      if (!contactPerson.trim()) {
        errors.push("Contact Person is mandatory");
      }
      if (gstInNumber && gstInNumber.trim() !== "" && gstInNumber.trim().length !== 15) {
        errors.push("GST No must be exactly 15 characters");
      }
      if (new Date(nextFollowUpDate) < new Date(InqDate)) {
        errors.push("Follow-up date cannot be earlier than Inquiry date.");
      }

      if (!leadsourceID || leadsourceID === "0") {
        errors.push("Source is required");
      }

      if (errors.length > 0) {
        setFormErrors(errors);
        return;
      }



      // ✅ Area required
      if (!area.trim()) {
        setAreaError("Area is required");
        setFormErrors(prev => [...prev, "Area is required"]);
        return;
      }

      if (!String(pincode).trim()) {
        setPincodeError("Pincode is required");
        setFormErrors(prev => [...prev, "Pincode is required"]);
        return;
      }

      // ✅ City required
      if (!city.trim()) {
        setCityError("City is required");
        setFormErrors(prev => [...prev, "City is required"]);
        return;
      }

      setIsSubmitting(true);
      const featureLabels = selectedFeatures.map(val => featureOptions.find(o => o.value === val)?.label).filter(Boolean);
      const featureValues = selectedFeatures.slice();
      const payloadOfferPrice = offerPrice;
      console.log("payloadOfferPrice", payloadOfferPrice);
      let uid = uId;
      const baseData = { InqDate, inquiryNumber, leadsourceID, leadSourceValue, userId, employeeName, leadStatusID, leadStatusValue, priorityID, priorityValue, mobile, alternateMobile, clientName, gstInNumber, contactPerson, email, alternateEmail, address, city, state: stateField, stateCode, remarks, nextFollowUpDate, pincode, clientId, companyId, uid, requirement: featureLabels, selectedFeatures: featureValues, offerPrice: payloadOfferPrice, closingPrice: parseFloat(closingPrice) || 0, addOn: addOnChecked, area, pincode };
      console.log("baseData", baseData);
      try {
        if (overallMode === "edit") {
          if (!inquiryId) {
            setSnackbar({ open: true, severity: "warning", message: "No inquiryId" });
            return;
          }
          const response = await axios.put(
            `${path}/api/inquiryupdate/${inquiryId}`,
            baseData
          );
          if (response.status === 200 && response.data.success) {
            // await createSaleInvoice({
            //   path,
            //   inquiryId,
            //   selectedFeatures: featureValues,
            //   inquiryNumber,
            //   leadStatusValue,
            //   connectionString
            // });
            if (typeof onClose === "function") {
              onClose();
            }
            setSnackbar({ open: true, severity: "success", message: "Inquiry updated successfully" });
            setTimeout(() => { navigate(-1); }, 600);
          } else {
            setSnackbar({ open: true, severity: "error", message: "Update failed!" });
          }
        } else if (overallMode === "followup") {
          const followupData = {
            inqid: inquiryId,
            inquiryNumber,
            clientId,
            nextFollowUpDate,
            leadSourceId: parseInt(leadsourceID) || 0,
            leadSourceName: leadSourceValue,
            activityId: 0,
            activityName: "",
            statusId: parseInt(leadStatusID) || 0,
            statusName: leadStatusValue,
            companyId,
            addUserId: parseInt(userId) || 0,
            employeeName,
            requirement: featureLabels,
            remark: remarks,
            qty: parseFloat(qty) || 0,
            rate: parseFloat(rate) || 0,
            amount: parseFloat(amount) || 0,
            lastpriorityid: parseInt(priorityID) || 0,
            lastpriority: priorityValue,
            selectedFeatures: featureValues,
            offerPrice: payloadOfferPrice,
            closingPrice: parseFloat(closingPrice) || 0,
            addOn: addOnChecked,
            reasonId: selectedReason?.value || null,
            reasonText: selectedReason?.label || null
          };
          console.log(followupData);
          const followupResponse = await axios.post(`${path}/api/inquiryfollowup`, followupData);
          if (followupResponse.status === 201) {
            // try {
            //   await createSaleInvoice({
            //     path,
            //     inquiryId,
            //     selectedFeatures: featureValues,
            //     inquiryNumber,
            //     leadStatusValue,
            //     connectionString
            //   });
            //   console.log("Sale invoice master created after follow-up");
            // } catch (err) {
            //   console.error("Failed to create sale invoice master:", err);
            // }
            //  setSnackbar({ open: true, severity: "Success", message: "Followup submitted successfully!" });   
            if (overallMode === "followup") {
              if (typeof onSuccess === "function") {
                onSuccess("Follow-up submitted successfully!");
              }
              handleClose();   // closes popup 🎯
              return;
            }

          } else {
            setSnackbar({ open: true, severity: "error", message: "Followup submission failed!" });
          }
        } else {
          let id = clientId;
          if (clientMode === "newClient" || clientMode === "new") {
            const clientResponse = await axios.post(`${path}/api/insertClient-inquiry`, { clientname: clientName, contactPerson, mobileNo: mobile, alternateMobile, emailId: email, alternateEmail, address, area, pinCode: pincode, city, state: stateField, stateCode, gstno: gstInNumber, companycode: companyId, addUserId: parseInt(uId) });
            if (clientResponse.status === 201 && clientResponse.data.success) {
              id = clientResponse.data.id;
              setClientId(id);
            } else {
              setSnackbar({ open: true, severity: "error", message: "Failed to insert client data!" });
              setIsSubmitting(false);
              return;
            }
          }
          if (!id) {
            setSnackbar({ open: true, severity: "warning", message: "Client ID is missing!" });
            setIsSubmitting(false);
            return;
          }
          const enquiryResponse = await axios.post(`${path}/api/enquiry`, { ...baseData, clientId: id, leadSourceName: leadSourceValue });
          if (enquiryResponse.status === 201) {
            if (typeof onClose === "function") {
              onClose();
            }
            setSnackbar({ open: true, severity: "success", message: "Inquiry Submitted successfully" });
            setTimeout(() => { navigate(-1); }, 600);
            clearFormFields();
          } else {
            alert("Submission failed!");
          }
        }
      } catch (error) {
        console.error("Error during submission:", error);
        alert("Something went wrong...!");
      } finally {
        setIsSubmitting(false);
      }
    },
    [inquiryId, InqDate, inquiryNumber, leadsourceID, leadSourceValue, userId, employeeName, leadStatusID, leadStatusValue, priorityID, priorityValue, mobile, clientName, gstInNumber, contactPerson, email, address, city, stateField, stateCode, remarks, nextFollowUpDate, pincode, clientId, overallMode, clientMode, navigate, selectedCompany?.CompId, qty, rate, amount, selectedFeatures, totalFeaturePrice, offerPrice, closingPrice, addOnChecked, selectedReason]
  );

  console.log("leadSourceId", leadsourceID)
  // Handler for when a new client is successfully added via the popup
  const handleClientAdded = (newClientData) => {
    if (newClientData) {
      // Populate the form with the new client data
      setClientId(newClientData.id || newClientData.clientId || "");
      setClientName(newClientData.FirmName || newClientData.clientName || "");
      setMobile(newClientData.MobileNo || newClientData.mobileNo || "");
      setAlternateMobile(newClientData.AlternateMobile || newClientData.alternateMobile || "");
      setContactPerson(newClientData.ContactPerson || newClientData.contactPerson || "");
      setEmail(newClientData.EmailId || newClientData.emailId || "");
      setAlternateEmail(newClientData.AlternateEmailId || newClientData.alternateEmail || "");
      setGstInNumber(newClientData.GSTNo || newClientData.gstNo || "");
      setAddress(newClientData.Address || newClientData.address || "");
      setArea(newClientData.Area || newClientData.area || "");
      setCity(newClientData.City || newClientData.city || "");
      setStateField(newClientData.state || "");
      setStateCode(newClientData.StateCode || newClientData.stateCode || "");
      setPincode(newClientData.Pincode ? String(newClientData.Pincode) : newClientData.pincode ? String(newClientData.pincode) : "");

      // Set mode to existing client since we now have a client ID
      setClientMode("existClient");
      setIsDisabled(true);
      setIsNew(false);

      setSnackbar({ open: true, message: "Client added successfully!", severity: "success" });
    }
    setOpenClientPopup(false);
  };

  // const searchOptions = [
  //   // { value: "", label: "-- Select --" },
  //   { value: "GSTNo", label: "GST No" },
  //   { value: "FirmName", label: "Company Name" },
  //   { value: "MobileNo", label: "Mobile No" },
  //   { value: "ContactPerson", label: "Contact Person" },
  // ];

  const disableLeftSection = overallMode === "followup" || clientMode === "existClient" || clientMode === "newClient";

  const inquiryLabel = displayMode.toLowerCase() === "edit" ? "Edit Inquiry" : displayMode.toLowerCase() === "followup" ? "Inquiry Follow-Up" : "Add New Inquiry";

  return (
    <Paper elevation={3} sx={{ p: 2, pt: 0.4, mt: 1, mx: "auto", maxWidth: 900 }}>
      <FormContainer>
        <Box onKeyDown={handleKeyDown} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 0, borderRadius: 1, mt: 1 }}>
          {/* <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mb: 3, mt: 2, textDecoration: "underline", textUnderlineOffset: 8 }}>
          Inquiry Form –{" "} <Typography component="span" variant="subtitle2" sx={{ mt: -1, color: "error.main", fontWeight: "semibold" }}> {inquiryLabel} </Typography>
        </Typography> */}
          <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mb: 1 }}>
            {inquiryLabel}
          </Typography>
          {/* <Divider
  sx={{
    width: "95%",
    my:1,
  }}
/> */}
          <Grid container spacing={1} sx={{ bgcolor: "grey.50", p: 1, border: "1px solid", borderColor: "grey.300", borderRadius: 1, fontSize: "0.875rem", fontWeight: 600, width: "95%", mb: 3 }}>
            <Grid item size={{ xs: 12, md: 2 }}> <FloatingLabelInput label="Inq No." name="inquiryNumber" value={inquiryNumber} disabled fullWidth sx={{
              '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
              '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
            }} /> </Grid>
            <Grid item size={{ xs: 12, md: 2 }}> {overallMode === "insert" ? (<DateInput label="Inq. Date" allowToday value={InqDate} onChange={(e) => setInqDate(e.target.value)} onTodaySelect={(today) => setInqDate(today)} fullWidth />) : (<DateInput label="Inq. Date" value={formatDateForInput(InqDate)} fullWidth disabled sx={{ height: 48 }} />)} </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Autocomplete fullWidth options={[...sourceOptions, { __addNew: true }]} getOptionLabel={(option) => option.__addNew ? "Add new source" : option.LeadSource || ""} value={sourceOptions.find((opt) => String(opt.LeadsourceID) === String(leadsourceID)) || null}
                // onChange={(e, newValue) => {
                //   if (!newValue) return;

                //   // 👉 Clicked "Add new"
                //   if (newValue.__addNew) {
                //     setShowAddSourceModal(true);
                //     return;
                //   }

                //   // 👉 Normal selection
                //   setLeadsourceID(String(newValue.LeadsourceID));
                //   setLeadSourceValue(newValue.LeadSource);
                // }}
                onChange={(e, newValue) => {
                  if (!newValue) {
                    setLeadsourceID("");
                    setLeadSourceValue("");
                    return;
                  }

                  if (newValue.__addNew) {
                    setLeadsourceID("");          // ✅ CLEAR
                    setLeadSourceValue("");       // ✅ CLEAR
                    setShowAddSourceModal(true);
                    return;
                  }

                  setLeadsourceID(String(newValue.LeadsourceID));
                  setLeadSourceValue(newValue.LeadSource);
                }}

                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Source"
                    required
                    size="small"
                    error={!leadsourceID && formErrors.includes("Source is required")}
                    helperText={
                      !leadsourceID && formErrors.includes("Source is required")
                        ? "Source is required"
                        : ""
                    }
                    InputLabelProps={{ sx: requiredAsteriskStyle }}
                    sx={{
                      '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                      '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                    }}
                  />
                )}
                renderOption={(props, option) => {
                  // 👉 Add New row
                  if (option.__addNew) {
                    return (
                      <li {...props}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            color: "primary.main",
                            fontWeight: 600,
                          }}
                        >
                          <AddIcon fontSize="small" />
                          <Typography>Add new source</Typography>
                        </Box>
                      </li>
                    );
                  }

                  // 👉 Normal option
                  return (
                    <li {...props}>
                      {toProperCase(option.LeadSource)}
                    </li>
                  );
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Dropdown id="assign" label="Assign" valueKey="UserId" y labelKey="employeeName" value={toProperCase(userId)} options={toProperCase(usersOptions)} onChange={handleAssignChange} fullWidth disabled={overallMode === "insert" || overallMode === "edit"}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiSelect-select": {
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                  },
                }} />
            </Grid>
            <Grid item size={{ xs: 12, md: 2 }}>
              <Dropdown id="priority" name="priority" label="Priority" valueKey="id" labelKey="value" value={priorityID} options={priorityOptions} onChange={handlePriorityChange} disabled={false} fullWidth />
            </Grid>

          </Grid>
          {overallMode === "insert" && (
            <Grid container spacing={1} alignItems="flex-start" sx={{ width: "100%", mb: 1, mt: -2 }}>
              <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "flex-start", px: 3, ml: 2 }}>  </Grid>
              <Grid itemsize={{ xs: 12 }} sx={{ display: "flex", width: '98%', pl: 3, pr: 1, mt: -2 }}>
                <Box sx={{ width: '100%', display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {/* <FormControlLabel control={<Checkbox id="newCompany" checked={isNew} onChange={Fn_HandleNewToggle} />} label="New ?" disabled /> */}
                  {/* <SearchSection   searchText={searchText} onSearchTextChange={Fn_HandleSearch} showResults={showResults} searchResults={searchResults} onSelectResult={Fn_HandleSelectedResult} isNew={isNew} onNewToggle={Fn_HandleNewToggle} onCloseResults={() => setShowResults(false)} openClientPopUp={() => setOpenClientPopup(true)} /> */}
                </Box>
              </Grid>
            </Grid>
          )}
          <Box sx={{ width: "95%", mb: 4, mt: -1.5 }}>
            <Grid container spacing={3} sx={{
              justifyContent: {
                xs: "center", // <600px
                sm: "center", // 600px–899px
              },
            }}>
              <Grid item size={{ xs: 12, md: 5.8 }}>
                <Box display="flex" flexDirection="column" gap={1.8}>
                  <Box sx={{ position: "relative" }}>
                    <FloatingLabelInput
                      label="Company Name"
                      name="clientName"
                      value={toProperCase(clientName)}
                      disabled={overallMode === "followup" || overallMode === "edit"}
                      onChange={(e) => {
                        const val = toProperCase(e.target.value);
                        setClientName(val);

                        // if user cleared the field, reset everything immediately
                        if (val.trim() === "") {
                          if (!val.trim()) {
                            setClientName("");
                            setClientId("");
                            setMobile("");
                            setAlternateMobile("");
                            setContactPerson("");
                            setEmail("");
                            setAlternateEmail("");
                            setGstInNumber("");
                            setAddress("");
                            setArea("");
                            setPincode("");
                            setCity("");
                            setStateField("");
                            setStateCode("");
                            setSearchText("");
                            setSearchResults([]);
                            setShowResults(false);

                            return;
                          }
                          setShowResults(false);
                          return;
                        }

                        Fn_HandleSearch(val); // trigger live search
                      }}

                      onFocus={() => {
                        if (searchResults.length > 0) setShowResults(true);
                      }}
                      onBlur={() => {
                        setTimeout(() => setShowResults(false), 200);
                      }}
                      fullWidth
                      required
                      sx={{
                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                        '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                      }}
                    />

                    {/* 🔽 SEARCH RESULT DROPDOWN */}
                    {showResults && clientName.trim() && (
                      <Paper
                        elevation={0}
                        sx={{
                          mt: 1,
                          position: "absolute",
                          width: { xs: "100%", md: "180%" },
                          zIndex: 1200,
                          border: "1px solid rgba(0,0,0,0.2)",
                          borderRadius: 1,
                          maxHeight: 260,
                          overflowY: "auto",
                          // left: { xs: 0, md: "50%" },
                          // transform: { md: "translateX(-50%)" }
                        }}
                      >
                        {/* ========== SMALL SCREEN - CARD VIEW ========== */}
                        {isSmallScreen ? (
                          <>
                            {searchResults.length > 0 ? (
                              searchResults.map((r, i) => (
                                <Box
                                  key={r.id || i}
                                  sx={{
                                    p: 1.2,
                                    borderBottom: `1px solid ${themeColors.neutral.border}`,
                                    cursor: "pointer"
                                  }}
                                  onMouseDown={() => {
                                    Fn_HandleSelectedResult(r);
                                    setShowResults(false);
                                  }}
                                >
                                  <Box sx={{ fontWeight: 600, fontSize: "0.85rem" }}>{toProperCase(r.FirmName)}</Box>

                                  <Box sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
                                    GST: {r.GSTNo || "-"}
                                  </Box>

                                  <Box sx={{ fontSize: "0.75rem" }}>
                                    {toProperCase(r.ContactPerson) || "-"} • {r.MobileNo || "-"}
                                  </Box>

                                  <Box sx={{ fontSize: "0.75rem", color: "text.secondary" }}>
                                    {toProperCase(r.City) || "-"}
                                  </Box>
                                </Box>
                              ))
                            ) : (
                              <Box sx={{ p: 2, textAlign: "center", color: "error.main" }}>
                                Client not found
                              </Box>
                            )}

                            {/* Sticky Add New Client */}
                            <Box
                              sx={{
                                position: "sticky",
                                bottom: 0,
                                backgroundColor: themeColors.neutral.surface,
                                textAlign: "center",
                                p: 1,
                                fontWeight: 600,
                                color: "primary.main",
                                cursor: "pointer",
                                boxShadow: "0 -2px 6px rgba(0,0,0,0.08)"
                              }}
                              onMouseDown={() => setOpenClientPopup(true)}
                            >
                              ➕ Add New Client
                            </Box>
                          </>
                        ) : (
                          /* ========== LARGE SCREEN - TABLE VIEW ========== */
                          <Table size="small" stickyHeader>
                            <TableHead>
                              <TableRow>
                                {["Company", "GST No", "Contact", "Mobile", "City"].map((h) => (
                                  <TableCell
                                    key={h}
                                    sx={{
                                      backgroundColor: themeColors.neutral.line,
                                      fontWeight: 600,
                                      fontSize: "0.75rem",
                                      position: "sticky",
                                      top: 0,
                                      zIndex: 1
                                    }}
                                  >
                                    {h}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {searchResults.length > 0 ? (
                                searchResults.map((r, i) => (
                                  <TableRow
                                    key={i}
                                    hover
                                    sx={{ cursor: "pointer" }}
                                    onMouseDown={() => {
                                      Fn_HandleSelectedResult(r);
                                      setShowResults(false);
                                    }}
                                  >
                                    <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                    <TableCell>{r.GSTNo || "-"}</TableCell>
                                    <TableCell>{toProperCase(r.ContactPerson) || "-"}</TableCell>
                                    <TableCell>{r.MobileNo || "-"}</TableCell>
                                    <TableCell>{toProperCase(r.City) || "-"}</TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={5} align="center" sx={{ color: "error.main" }}>
                                    Client not found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>

                            <TableFooter
                              sx={{
                                position: "sticky",
                                bottom: 0,
                                backgroundColor: themeColors.neutral.surface
                              }}
                            >
                              <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                <TableCell colSpan={5} align="center" sx={{ color: "primary.main", fontWeight: 600 }}>
                                  ➕ Add New Client
                                </TableCell>
                              </TableRow>
                            </TableFooter>
                          </Table>
                        )}
                      </Paper>
                    )}

                  </Box>

                  <Box sx={{ position: "relative" }}>
                    <FloatingLabelInput
                      label="Mobile"
                      name="mobile"
                      value={mobile}
                      sx={{
                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                        '& .MuiFormHelperText-root': {
                          position: 'absolute',
                          bottom: -16,        // lock it below input
                          margin: 0,
                          lineHeight: '14px',
                        },
                        '& .MuiFormControl-root': {
                          position: 'relative',
                          paddingBottom: '18px !important', // reserve height
                        }
                      }}
                      inputProps={{ maxLength: 10 }}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        setMobile(val);

                        if (val.length > 0 && val.length < 10) {
                          setMobileError("Mobile number must be 10 digits");
                        } else {
                          setMobileError("");
                        }
                      }}
                      onBlur={() => {
                        if (mobile.trim() === "") {
                          setMobileError("Mobile is required");
                        } else if (mobile.length < 10) {
                          setMobileError("Mobile number must be 10 digits");
                        }
                      }}
                      error={Boolean(mobileError)}
                      helperText={mobileError}
                      disabled={disableLeftSection}
                      fullWidth
                      required
                    />
                  </Box>
                  <FloatingLabelInput label="Alternate Mobile" name="alternateMobile" value={alternateMobile} onChange={e => setAlternateMobile(e.target.value.replace(/[^\d]/g, ""))} disabled={disableLeftSection} fullWidth sx={{
                    mt: mobileError ? 2 : 0, '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                    "& .MuiFormLabel-asterisk": { color: "inherit", },
                  }} />
                  <FloatingLabelInput label="Contact Person" name="contactPerson" value={toProperCase(contactPerson)} onChange={(e) => setContactPerson(e.target.value)} disabled={disableLeftSection} fullWidth required
                    sx={{
                      '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                      '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                    }} />
                  {/* <FloatingLabelInput
                  label="Email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    const val = e.target.value;
                    setEmail(val);

                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (val && !emailRegex.test(val)) {
                      setEmailError("Invalid email format");
                    } else {
                      setEmailError("");
                    }
                  }}
                  onBlur={() => {
                    if (email.trim() === "") {
                      setEmailError("Email is required");
                    }
                  }}
                  error={Boolean(emailError)}
                  helperText={emailError}
                  disabled={disableLeftSection}
                  fullWidth
                  required
                  sx={{ '& .MuiInputBase-root': { height: 40 }, "& .MuiFormLabel-asterisk": { color: "inherit", } }}
                /> */}
                  <Box sx={{ position: "relative" }}>
                    <FloatingLabelInput
                      label="Email"
                      name="email"
                      type="email"
                      value={email}
                      onChange={(e) => {
                        const val = e.target.value;
                        setEmail(val);

                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (val && !emailRegex.test(val)) {
                          setEmailError("Invalid email format");
                        } else {
                          setEmailError("");
                        }
                      }}
                      onFocus={() => setShowEmailSuggestions(true)}
                      onBlur={() => {
                        // ⏳ delay so suggestion click works
                        setTimeout(() => {
                          setShowEmailSuggestions(false);

                          if (email.trim() === "") {
                            setEmailError("Email is required");
                          }
                        }, 150);
                      }}
                      error={Boolean(emailError)}
                      helperText={emailError}
                      disabled={disableLeftSection}
                      fullWidth
                      required
                      sx={{
                        "& .MuiInputBase-root": { height: 38 },
                      }}
                    />

                    {/* 🔹 Tooltip-like email suggestions */}
                    {showEmailSuggestions && !disableLeftSection && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "calc(100% + 8px)",
                          left: 12,
                          bgcolor: themeColors.neutral.surface,
                          borderRadius: 2,
                          px: 1,
                          py: 0.5,
                          zIndex: 20,
                          boxShadow: "0px 6px 18px rgba(0,0,0,0.15)",
                          minWidth: 260,
                        }}
                      >
                        {/* arrow */}
                        <Box
                          sx={{
                            position: "absolute",
                            top: -6,
                            left: 16,
                            width: 12,
                            height: 12,
                            bgcolor: themeColors.neutral.surface,
                            transform: "rotate(45deg)",
                          }}
                        />

                        {EMAIL_SUGGESTIONS
                          .filter(
                            (item) =>
                              !email ||
                              item.toLowerCase().includes(email.toLowerCase())
                          )
                          .map((item) => (
                            <Box
                              key={item}
                              sx={{
                                px: 1.5,
                                py: 0.75,
                                fontSize: 13,
                                borderRadius: 1,
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                "&:hover": {
                                  backgroundColor: "#f0f4ff",
                                },
                              }}
                              onMouseDown={() => {
                                // 👈 IMPORTANT
                                setEmail(item);
                                setEmailError("");
                              }}
                            >
                              {item}
                            </Box>
                          ))}
                      </Box>
                    )}
                  </Box>


                  <FloatingLabelInput label="Alternate Email" name="alternateEmail" type="email" size="small" value={alternateEmail} onChange={(e) => setAlternateEmail(e.target.value)} disabled={disableLeftSection} sx={{ '& .MuiInputBase-root': { height: 38 }, mt: emailError ? 2 : 0 }} fullWidth />

                  <TextField label="Address" value={toProperCase(address)} onChange={(e) => setAddress(e.target.value)} disabled={disableLeftSection} fullWidth multiline minRows={2} />
                </Box>
              </Grid>
              <Grid item size={{ xs: 12, md: 6 }}>
                <Box display="flex" flexDirection="column" gap={1.8}>
                  <Box display="flex" gap={1}>
                    <TextField label="Area" size="small" fullWidth required value={toProperCase(area)} disabled={disableLeftSection} error={Boolean(areaError)} helperText={areaError}
                      onBlur={(e) => {
                        const v = e.target.value.trim();
                        if (!v) setAreaError("Area is required");
                      }}
                      onChange={(e) => {
                        setArea(e.target.value);
                        if (areaError) setAreaError("");
                      }}
                      InputLabelProps={{ sx: requiredAsteriskStyle }}
                      sx={{
                        '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                        '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                      }}
                    />

                    <TextField label="Pincode" size="small" fullWidth required inputProps={{ maxLength: 6 }} value={pincode} disabled={disableLeftSection} error={Boolean(pincodeError)} helperText={pincodeError} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{
                      '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                      '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                    }}
                      onBlur={(e) => {
                        const v = e.target.value.trim();
                        if (!v) {
                          setPincodeError("Pincode is required");
                        } else if (!/^\d{6}$/.test(v)) {
                          setPincodeError("Invalid pincode");
                        } else {
                          setPincodeError("");
                        }
                      }}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        setPincode(val); // Make sure it's a string
                        if (pincodeError) setPincodeError("");
                      }}
                    />
                  </Box>
                  <CitySearchInput value={city} disabled={disableLeftSection} cities={cities} fullWidth connectionString={connectionString}
                    onSelectCity={(c) => {
                      setCity(c.city);
                      setStateField(c.state);
                      setStateCode(c.stateCode);
                      setCityError("");
                    }}
                  />
                  {cityError && (
                    <Typography variant="caption" color="error">
                      {cityError}
                    </Typography>
                  )}
                  {stateField && (
                    <Box display="flex" gap={1}>
                      <FloatingLabelInput label="State" name="state" value={toProperCase(stateField)} disabled fullWidth required InputLabelProps={{ sx: requiredAsteriskStyle }} />
                      <FloatingLabelInput label="State Code" name="stateCode" value={stateCode} disabled fullWidth required InputLabelProps={{ sx: requiredAsteriskStyle }} />
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      width: "100%",
                    }}
                  >
                    {/* <Dropdown id="status" name="status" label="Status" valueKey="LeadStatusID" labelKey="LeadStatus" value={leadStatusID} options={statusOptions} onChange={handleStatusChange} disabled={false} fullWidth /> */}
                    <Box sx={{ flex: 1 }}>
                      <Autocomplete
                        fullWidth
                        options={[...statusOptions, { __addNew: true }]}
                        getOptionLabel={(option) => option.__addNew ? "Add new status" : option.LeadStatus || ""}
                        value={statusOptions.find((opt) => String(opt.LeadStatusID) === String(leadStatusID)) || null}
                        // onChange={(e, newValue) => {
                        //   if (!newValue) {
                        //     setLeadStatusID("");
                        //     setLeadStatusValue("");
                        //     return;
                        //   }

                        //   if (newValue.__addNew) {
                        //     setShowAddStatusModal(true);
                        //     return;
                        //   }

                        //   setLeadStatusID(Number(newValue.LeadStatusID));
                        //   setLeadStatusValue(newValue.LeadStatus);
                        //   const failed = newValue.LeadStatus.toLowerCase() === "failed";
                        //   setIsFailed(failed);
                        //   setShowReasonDropdown(overallMode === "followup" && failed);
                        // }}
                        onChange={(e, newValue) => {
                          if (!newValue) {
                            setLeadStatusID("");
                            setLeadStatusValue("");
                            setCategory("");
                            setShowReasonDropdown(false);
                            return;
                          }

                          if (newValue.__addNew) {
                            setShowAddStatusModal(true);
                            return;
                          }

                          setLeadStatusID(String(newValue.LeadStatusID));
                          setLeadStatusValue(newValue.LeadStatus);
                          setCategory(newValue.Category || "");  // <-- Use API category

                          const isFailed = (newValue.Category || "").toLowerCase() === "failed";
                          setIsFailed(isFailed);
                          setShowReasonDropdown(overallMode === "followup" && isFailed);
                        }}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Status"
                            required
                            size="small"
                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                            sx={{ '& .MuiInputBase-root': { height: 38 } }}
                          />
                        )}
                        renderOption={(props, option) => {
                          if (option.__addNew) {
                            return (
                              <li {...props}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    color: "primary.main",
                                    fontWeight: 600,
                                  }}
                                >
                                  <AddIcon fontSize="small" />
                                  <Typography>Add new status</Typography>
                                </Box>
                              </li>
                            );
                          }
                          return (
                            <li {...props}>
                              {option.LeadStatus}
                            </li>
                          );
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <DateInput fullWidth label="Follow-Up Date" allowToday={overallMode === "insert"} value={nextFollowUpDate}
                        onChange={(e) => {
                          setNextFollowUpDate(e.target.value);
                          setFollowupDateManuallySet(true);
                        }}
                      />
                    </Box>
                  </Box>
                  {overallMode === "followup" && showReasonDropdown && (

                    <ReasonSearchDropdown options={reasonOptions} value={selectedReason?.label || ""} onSelect={opt => setSelectedReason({ value: opt.ReasonID, label: opt.Reason })} onAddNew={() => setShowAddNewReasonModal(true)}
                      onSearch={async term => {
                        const res = await axios.get(`${path}/api/reasons`, { params: { search: term, companyId: companyId } });
                        setReasonOptions(res.data.data);
                      }}
                    />
                  )}

                  {/* <TextField disabled fullWidth label="Selected Product" multiline minRows={2.9} value={selectedFeatures.map((val) => featureOptions.find((o) => o.value === val)?.label).filter(Boolean).join(", ")} /> */}
                  <TextField fullWidth label="Remarks" value={remarks} multiline minRows={1} onChange={(e) => setRemarks(e.target.value)} disabled={overallMode === "followup" && leadStatusValue === "Failed"}
                  />

                  <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
                    <TextField label="Offer Price" size="small" fullWidth value={offerDisplay} onChange={onOfferChange} onBlur={(e) => { onOfferBlur(e); }} onFocus={onOfferFocus} inputProps={{ inputMode: "decimal", style: { height: 38 } }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                        style: { height: 38 }
                      }}
                    />
                    <TextField label="Closing Price" size="small" fullWidth value={closingDisplay} onChange={onClosingChange} onBlur={(e) => { onClosingBlur(e); }} onFocus={onClosingFocus} inputProps={{ inputMode: "decimal", pattern: "[0-9]*[.,]?[0-9]*", style: { height: 38 } }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                        style: { height: 38 }
                      }}
                    />
                  </Box>
                  {/* <Box sx={{ mt: 1 }}>
                  <FormControlLabel label="Add On ?" control={<Checkbox checked={addOnChecked} onChange={(e) => setAddOnChecked(e.target.checked)} name="addOn" color="primary" />} />
                </Box> */}
                </Box>
              </Grid>
              {/* <Grid item xs={12} md={4}>
              <Paper sx={{ p: 2, maxHeight: 480, overflowY: "auto" }}>
                <Typography variant="subtitle1" gutterBottom> Selected Product </Typography>
                <FormGroup>
                  {featureOptions.map(opt => (
                    <FormControlLabel
                      key={opt.value}
                      control={<Checkbox size="small" checked={selectedFeatures.includes(opt.value)} onChange={() => handleFeatureToggle(opt.value)} />}
                      label={`${opt.label}`}
                    />
                  ))}
                </FormGroup>
              </Paper>
            </Grid> */}
            </Grid>
            {formErrors.length > 0 && (
              <Box sx={{ mx: "auto", maxWidth: 400, p: 2, bgcolor: "red.50", border: 1, borderColor: "red.500", borderRadius: 1, color: "red.700", mt: 3 }}>
                <Typography fontWeight="bold">Please fix:</Typography>
                <ul>
                  {formErrors.map((e, i) => (<li key={i}>{e}</li>))}
                </ul>
              </Box>
            )}
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, mt: 3, justifyContent: "center" }}>
              <Button onClick={handleSubmit} variant="contained" color="primary" sx={{ minWidth: 120, height: 38 }} disabled={
                isSubmitting ||
                !isFormComplete()
              }>
                {isSubmitting
                  ? <CircularProgress size={24} />
                  : overallMode === "edit"
                    ? "Update"
                    : "Submit"}
              </Button>
              {/* {overallMode !== "followup" && ( */}
              <Button onClick={handleClose} variant="contained" color="error" sx={{ minWidth: 120, height: 38 }} disabled={isSubmitting}>
                Cancel
              </Button>
              {/* )} */}
            </Box>
          </Box>
        </Box>
        <AddNewReasonModal open={showAddNewReasonModal} onClose={() => setShowAddNewReasonModal(false)} connectionString={connectionString}
          onSubmit={(newReason) => {
            // This runs after successful insert
            setReasonOptions(prev => [...prev, newReason]);
            setSelectedReason({ value: newReason.ReasonID, label: newReason.Reason });
            setShowAddNewReasonModal(false);
          }}
        />

        <Dialog open={showAddSourceModal} onClose={(event, reason) => {
          if (reason === 'backdropClick') return; // ❌ block outside click
          setShowAddSourceModal(false);           // ✅ allow Cancel / Save
        }} maxWidth="sm" fullWidth>
          <LeadSourceMaster
            mode="add"
            onPopupCancel={(data) => { handlePopupClose(data); setShowAddSourceModal(false) }}
            loggedInUser={user}
            companyData={{ companyId: selectedCompany?.CompId, financialYear: selectedCompany?.FinancialYear }}
            connectionString={connectionString}
          />
        </Dialog>

        <Dialog open={showAddStatusModal} onClose={(event, reason) => {
          if (reason === 'backdropClick') return; // ❌ block outside click
          setShowAddStatusModal(false);           // ✅ allow Cancel / Save
        }} maxWidth="sm" fullWidth>
          <LeadStatusMaster
            mode="add"
            // onPopupCancel={() => setShowAddStatusModal(false)}
            onPopupCancel={(data) => { handlePopupClose(data); setShowAddStatusModal(false) }}
            connectionString={connectionString}
          />
        </Dialog>
        {/* <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} >
          <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: "100%" }} variant="filled">
            {snackbar.message}
          </Alert>
        </Snackbar> */}
        <Dialog
          open={openClientPopup}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return; // ❌ block outside click
            setOpenClientPopup(false);              // ✅ allow Cancel / Save
          }}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { minHeight: '60vh' } }}
        >
          <ClientMaster
            mode="add"
            onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }}
            onClientAdded={handleClientAdded}
            connectionString={connectionString}
          />
        </Dialog>
      </FormContainer>

      <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
        <Alert onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
}

export default InquiryForm;